export default __webpack_public_path__ + "static/media/payment-shopeepay.a34eb12a.svg";